
import { Button } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';

function BRRTitle({ title, dark }) {
    const textColor = dark? "text-white": "text-dark"

    return (
        <div className='d-flex flex-column align-items-center mb-5'>
            <h1 className={`text-center my-5 fw-bolder ${textColor} mb-3`}>{title}</h1>
            <span className='bg-warning' style={{ height: "8px", width: "100px", display: "block" }} />
        </div>
    );
}

export default BRRTitle;

